import {
  GET_MARCAS,
  GET_MARCAS_SUCCESS,
  GET_MARCAS_FAILED,
  GET_BRAND_BY_MODEL,
  GET_BRAND_BY_MODEL_SUCCESS,
  GET_BRAND_BY_MODEL_FAILED,
  GET_MODELOS,
  GET_MODELOS_SUCCESS,
  GET_MODELOS_FAILED,
  GET_HOMOLOGATION,
  GET_HOMOLOGATION_SUCCESS,
  GET_HOMOLOGATION_FAILED,
  GET_HOMOLOGATED_CARS,
  GET_HOMOLOGATED_CARS_SUCCESS,
  GET_HOMOLOGATED_CARS_FAILED,
  GET_GASTOS,
  GET_GASTOS_SUCCESS,
  GET_GASTOS_FAILED,
  GET_PLAZOS,
  GET_PLAZOS_SUCCESS,
  GET_PLAZOS_FAILED,
  GET_PRODUCTS,
  GET_PRODUCTS_SUCCESS,
  GET_PRODUCTS_FAILED,
  POST_CALCULATE_FEE,
  POST_CALCULATE_FEE_SUCCESS,
  POST_CALCULATE_FEE_FAILED,
  GET_TYPE_PRODUCTS,
  GET_TYPE_PRODUCTS_SUCCESS,
  GET_TYPE_PRODUCTS_FAILED,
  GET_TASA_VFMG,
  GET_TASA_VFMG_SUCCESS,
  GET_TASA_VFMG_FAILED,
  POST_INYECTION_TRINIDAD,
  POST_INYECTION_TRINIDAD_SUCCESS,
  POST_INYECTION_TRINIDAD_FAILED,
  GET_CES_SPIDER,
  GET_CES_SPIDER_SUCCESS,
  GET_CES_SPIDER_FAILED,
  GET_HOMOLOGATED,
  GET_HOMOLOGATED_SUCCESS,
  GET_HOMOLOGATED_FAILED,
  GET_MONTHS,
  GET_MONTHS_SUCCESS,
  GET_MONTHS_FAILED,
  GET_REGISTRATION_FAILED,
  GET_REGISTRATION,
  GET_REGISTRATION_SUCCESS
} from "../actions/types";

const initialState = {
  loading: false,
  loadingFee: false,
  loadingMonths: false,
  monthsList: [],
  marcas: [],
  modelos: [],
  gastos: [],
  plazos: [],
  productos: [],
  cuota: {},
  typeProducts: [],
  tasaVFMG: [],
  trinidad: {},
  dataCes: {},
  homologationData: {},
  homologatedCars: {},
  homologated: [],
  isHomologated: false,
  brandByModel: {},
  registration: {
    data: null,
    loading: false,
    error: false
  }
};

const SpiderReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_TYPE_PRODUCTS:
      return { ...state, loading: true };
    case GET_TYPE_PRODUCTS_SUCCESS:
      return {
        ...state,
        loading: false,
        typeProducts: action.payload,
      };
    case GET_TYPE_PRODUCTS_FAILED:
      return { ...state, error: action.error };
    case GET_MARCAS:
      return { ...state, loading: true };
    case GET_MARCAS_SUCCESS:
      return {
        ...state,
        loading: false,
        marcas: action.payload,
      };
    case GET_MARCAS_FAILED:
      return {
        ...initialState,
        loading: false,
        error: action.error,
      };
    case GET_REGISTRATION:
      return {
        ...state,
        registration: {
          ...initialState.registration,
          loading: true
        }
      };
    case GET_REGISTRATION_SUCCESS:
      return {
        ...state,
        registration: {
          ...initialState.registration,
          data: action.payload.body,
          loading: false
        }
      };
    case GET_REGISTRATION_FAILED:
      return {
        ...state,
        registration: {
          ...initialState.registration,
          error: action.error,
          loading: false
        }
      };
    case GET_BRAND_BY_MODEL:
      return { ...state, loading: true };
    case GET_BRAND_BY_MODEL_SUCCESS:
      return {
        ...state,
        loading: false,
        brandByModel: action.payload,
      };
    case GET_BRAND_BY_MODEL_FAILED:
      return { ...state, error: action.error };
    case GET_CES_SPIDER:
      return { ...state, loading: true };
    case GET_CES_SPIDER_SUCCESS:
      return {
        ...state,
        loading: false,
        dataCes: action.payload,
      };
    case GET_CES_SPIDER_FAILED:
      return { ...state, error: action.error };
    case GET_MODELOS:
      return { ...state, loading: true };
    case GET_MODELOS_SUCCESS:
      return {
        ...state,
        loading: false,
        modelos: action.payload,
      };
    case GET_MODELOS_FAILED:
      return {
        modelos: [],
        loading: false,
        error: action.error,
      };
    case GET_HOMOLOGATION:
      return { ...state, loading: true };
    case GET_HOMOLOGATION_SUCCESS:
      return {
        ...state,
        loading: false,
        homologationData: action.payload,
      };
    case GET_HOMOLOGATION_FAILED:
      return { ...state, error: action.error };
    case GET_HOMOLOGATED_CARS:
      return { ...state, loading: true };
    case GET_HOMOLOGATED_CARS_SUCCESS:
      return {
        ...state,
        loading: false,
        homologatedCars: action.payload,
      };
    case GET_HOMOLOGATED_CARS_FAILED:
      return { ...state, error: action.error };
    case GET_HOMOLOGATED:
      return { ...state, loading: true };
    case GET_HOMOLOGATED_SUCCESS:
      return {
        ...state,
        loading: false,
        homologated: action.payload,
      };
    case GET_HOMOLOGATED_FAILED:
      return { ...state, error: action.error };
    case GET_MONTHS:
      return { ...state, loadingMonths: true };
    case GET_MONTHS_SUCCESS:
      return {
        ...state,
        loadingMonths: false,
        monthsList: action.payload,
      };
    case GET_MONTHS_FAILED:
      return { ...state, error: action.error, loadingMonths: false };
    case GET_GASTOS:
      return { ...state, loading: true };
    case GET_GASTOS_SUCCESS:
      return {
        ...state,
        loading: false,
        gastos: action.payload,
      };
    case GET_GASTOS_FAILED:
      return { ...state, error: action.error };
    case GET_PLAZOS:
      return { ...state, loading: true };
    case GET_PLAZOS_SUCCESS:
      return {
        ...state,
        loading: false,
        plazos: action.payload,
      };
    case GET_PLAZOS_FAILED:
      return { ...state, error: action.error };

    case GET_PRODUCTS:
      return { ...state, loading: true };
    case GET_PRODUCTS_SUCCESS:
      return {
        ...state,
        loading: false,
        productos: action.payload,
      };
    case GET_PRODUCTS_FAILED:
      return { ...state, error: action.error };

    case POST_CALCULATE_FEE:
      return { ...state, loadingFee: true };
    case POST_CALCULATE_FEE_SUCCESS:
      return {
        ...state,
        loadingFee: false,
        cuota: action.payload,
      };
    case POST_CALCULATE_FEE_FAILED:
      return { ...state, error: action.error, loadingFee: false };
    case GET_TASA_VFMG:
      return { ...state, loading: true };
    case GET_TASA_VFMG_SUCCESS:
      return {
        ...state,
        loading: false,
        tasaVFMG: action.payload,
      };
    case GET_TASA_VFMG_FAILED:
      return { ...state, error: action.error };
    case POST_INYECTION_TRINIDAD:
      return { ...state, loading: true };
    case POST_INYECTION_TRINIDAD_SUCCESS:
      return {
        ...state,
        loading: false,
        trinidad: action.payload,
      };
    case POST_INYECTION_TRINIDAD_FAILED:
      return { ...state, error: action.error };
    default:
      return state;
  }
};

export default SpiderReducer;
